module.exports = __webpack_public_path__ + "static/img/星图-设备类型.5f4e7154.png";